var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForecastLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C3.27688 0 1.875 1.3458 1.875 3V4.8H1.25C0.56 4.8 0 5.3376 0 6V10.8C0 11.4624 0.56 12 1.25 12H2.5H4.375H5.625H6.875H8.75C9.44 12 10 11.4624 10 10.8V6C10 5.3376 9.44 4.8 8.75 4.8H8.125V3C8.125 1.3458 6.72312 0 5 0ZM3.125 3C3.125 2.0076 3.96625 1.2 5 1.2C6.03375 1.2 6.875 2.0076 6.875 3V4.8H3.125V3ZM5.625 9.4338V10.8H4.375V9.4338C3.92062 9.1806 3.64437 8.667 3.78813 8.0994C3.89812 7.6674 4.27563 7.3182 4.72938 7.2276C5.53813 7.0644 6.25 7.6518 6.25 8.4C6.25 8.8434 5.9975 9.2262 5.625 9.4338Z",
    fill: "#3F4347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecastLock);
export default __webpack_public_path__ + "static/media/forecast-lock.9114a260463d6958e2d9db1138b99f9d.svg";
export { ForwardRef as ReactComponent };